module.exports = __webpack_public_path__ + "static/media/communication-smart.fe8fb805.svg";